import React, { useState, useEffect, useRef } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { searchProductsAPI } from "../services/ProductService";

import SearchIcon from "../static/search.svg";
function SearchAutoComplete(props) {
  const [display, setDisplay] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const { height } = props;

  const wrapperRef = useRef(null);

  const debounce = (callback, delay = 1000) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };
  const updateDebounce = debounce((keyword) => {
    searchProducts(keyword);
  });

  const handleSearch = (e) => {
    const keyword = e.target.value.trim();
    if(keyword === ''){
      setDisplay(false);
      setIsLoading(false);
    }else{console.log(keyword)
      setIsLoading(true);

      updateDebounce(keyword);
    }
    
  };

  const searchProducts = (keyword) => {
    const products = [];
    if (keyword !== "") {
      searchProductsAPI(keyword, 1, 20)
        .then(function (response) {
          let tempitemList = response;

          tempitemList.map((item) => {
            products.push({
              id: item.id,
              pictureUrl: item.pictureUrl,
              name: item.name,
            });
          });

          if (products.length > 0) {
            setDisplay(true);
          } else {
            setDisplay(true);
          }
          setIsLoading(false);
          setOptions(products);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else if (keyword === "") {
      setOptions([]);
      setDisplay(false);
    }
  };

  const hideSearchResults = () => {
    if (window.scrollY >= height) {
      setDisplay(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", hideSearchResults);

    return () => {
      window.removeEventListener("scroll", hideSearchResults);
    };
  });

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    const { current: wrap } = wrapperRef;

    if (wrap && !wrap.contains(e.target)) {
      setDisplay(false);
      setIsLoading(false);
    }
  };

  return (
    <div className="autocompletesearch" ref={wrapperRef}>
      <span className="searchIcon">
        <img src={SearchIcon} />
      </span>
      <input placeholder="Search for items" onChange={handleSearch} />

      {!isLoading && display && (
        <div className={`search-results ${display ? "show" : ""}`}>
          {options.length <= 0 && (
            <a href="#">
              <span className="search-item-name">Nothing Found</span>
            </a>
          )}
          {options.map((v, i) => {
            return (
              <Link key={i} to={`/productDetails/${v.id}`}>
                <img className="search-item-icon" src={v.pictureUrl} />
                <span className="search-item-name">{v.name}</span>
              </Link>
            );
          })}
        </div>
      )}

      <span className="searchIcon">
        {isLoading && (
          <a href="#">
            <Spinner
              variant="info"
              className=""
              size="sm"
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </a>
        )}
      </span>
    </div>
  );
}

export default SearchAutoComplete;
